import React from "react";
import Editor from "../../../Editor/Editor";
import { useContext, useEffect, useState } from "react";
import { SmetaModalsButtonsContext } from "../../Tools/modalManager";
import clsx from "clsx";
import dialogStyles from "./Components/dialogStyles.module.css";

interface DialogWithTextFieldProps {
  props: {
    Value?: string;
    Title?: string;
    Buttons?: string;
    hiddenButton?: boolean;
    from?: string;
    func?: (data?: any) => any;
    onSelect?: (data: any) => void;
  };
}

/**
 * Контент для диалога с текстовым полем
 *
 * Поля компонента:
 *    1. [inputText, setInputText] - состояние значения редактора
 *
 * @param  props объект с данными для компонента диалога адресов
 * @param  props.Value значение редактора
 * @param  props.Title заголовок редактора
 * @param  props.Buttons кнопки диалога
 * @param  props.hiddenButton скрыть кнопки
 * @param  props.onSelect функция при клике на кнопку выбрать
 * @returns Возвращает контент для диалога с текстовым полем
 */
export default function DialogWithTextField({ props }: DialogWithTextFieldProps) {
  const { Value: value, Title: title, Buttons: buttons, hiddenButton, onSelect } = props;
  const [inputText, setInputText] = useState(value);
  const setButtons = useContext(SmetaModalsButtonsContext);

  useEffect(() => {
    if (hiddenButton) return;
    const modalButtons: { [key: number]: { label: string; onClick?: () => void } } = {};
    if (!buttons || Number(buttons) & 1) {
      modalButtons[1] = { label: "Сохранить", onClick: onSelectClick };
    }
    setButtons?.(modalButtons);
  }, [setButtons, inputText]);

  /**
   * Устанавливает новое значение родительскому элементу
   */
  const onSelectClick = () => {
    onSelect?.({ ...props, value: inputText });
  };

  /**
   * Изменяет установленное значение при редактировании
   * @param data данные от редактора
   */
  const onEditEnd = (data: { value: string }) => {
    setInputText(data.value);
  };

  return (
    <div className={clsx(dialogStyles.mainDialogBlock)}>
      <div className={clsx(dialogStyles.fullDialogFlexContainer, dialogStyles.dialogWithTextFieldContainer)}>
        <div className={clsx(dialogStyles.dialogWithTextFieldTitle)}>{title || ""}</div>
        <div className={clsx(dialogStyles.dialogWithTextFieldInput)}>
          <Editor value={value} onEdit={onEditEnd} />
        </div>
      </div>
    </div>
  );
}
